import { Component, input, model } from '@angular/core';
import { NgClass } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { AbstractCoreComponent } from '@shared/abstracts/abstract-core.component';

@Component({
  selector: 'app-info-card',
  imports: [
    NgClass,
    SkeletonModule,
  ],
  providers: [],
  template: `
    <div [id]="uuid" class="card mb-0 w-auto h-44"
         tabindex="0" (click)="onClick($event)" (keydown.enter)="onClick($event)"
         [ngClass]="{
          'cursor-pointer hover:shadow-md': !loading() && clickable()
         }">
      <div class="flex justify-between mb-4">
        <div>
          <ng-content select=".card-label">
            <span class="block text-500 font-medium mb-3">{{ label() }}</span>
          </ng-content>
          <ng-content select=".card-value">
            @if (loading()) {
              <div class="font-medium text-xl">
                <p-skeleton shape="circle" size="1.5rem" styleClass="mr-2"/>
              </div>
            } @else {
              <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{ value() }}</div>
            }
          </ng-content>
        </div>
        <ng-content select=".card-icon">
          <div class="card-icon flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
               style="width:2.5rem;height:2.5rem">
            <i class="pi pi-question !text-xl"></i>
          </div>
        </ng-content>
      </div>
      <ng-content select=".card-footer"></ng-content>
    </div>
  `
})
export class InfoCardComponent extends AbstractCoreComponent {
  label = input<string | null>(null);

  value = input<number | null>(null);

  loading = input<boolean>(false);

  clickable = model<boolean>();

  protected onClick(event: Event): void {
    const clickable = this.clickable();
    const loading = this.loading();
    if (!clickable || loading) {
      event.stopImmediatePropagation();
    }
  }
}
